/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { CreateInvitationRequest } from '../models/createInvitationRequest';

import type { CreateInvitationResponse } from '../models/createInvitationResponse';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * List pending invitations for the tenant. Requires admin.
 * @summary List Invitations
 */
export const listInvitationsApiV1InvitationsGet = (signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/v1/invitations`,
    method: 'GET',
    signal
  });
};

export const getListInvitationsApiV1InvitationsGetQueryKey = () => {
  return [`/api/v1/invitations`] as const;
};

export const getListInvitationsApiV1InvitationsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListInvitationsApiV1InvitationsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>
  > = ({ signal }) => listInvitationsApiV1InvitationsGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListInvitationsApiV1InvitationsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>
>;
export type ListInvitationsApiV1InvitationsGetQueryError = unknown;

export function useListInvitationsApiV1InvitationsGet<
  TData = Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
          TError,
          Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListInvitationsApiV1InvitationsGet<
  TData = Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
          TError,
          Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListInvitationsApiV1InvitationsGet<
  TData = Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Invitations
 */

export function useListInvitationsApiV1InvitationsGet<
  TData = Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listInvitationsApiV1InvitationsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListInvitationsApiV1InvitationsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an invitation for a new user to join the tenant.

Admins can always invite. Non-admins can invite if allow_user_invitations is enabled.
Only admins can grant admin privileges to invitees.
 * @summary Create Invitation
 */
export const createInvitationApiV1InvitationsPost = (
  createInvitationRequest: CreateInvitationRequest,
  signal?: AbortSignal
) => {
  return customInstance<CreateInvitationResponse>({
    url: `/api/v1/invitations`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createInvitationRequest,
    signal
  });
};

export const getCreateInvitationApiV1InvitationsPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvitationApiV1InvitationsPost>>,
    TError,
    { data: CreateInvitationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvitationApiV1InvitationsPost>>,
  TError,
  { data: CreateInvitationRequest },
  TContext
> => {
  const mutationKey = ['createInvitationApiV1InvitationsPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvitationApiV1InvitationsPost>>,
    { data: CreateInvitationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createInvitationApiV1InvitationsPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInvitationApiV1InvitationsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInvitationApiV1InvitationsPost>>
>;
export type CreateInvitationApiV1InvitationsPostMutationBody =
  CreateInvitationRequest;
export type CreateInvitationApiV1InvitationsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Invitation
 */
export const useCreateInvitationApiV1InvitationsPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createInvitationApiV1InvitationsPost>>,
      TError,
      { data: CreateInvitationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createInvitationApiV1InvitationsPost>>,
  TError,
  { data: CreateInvitationRequest },
  TContext
> => {
  const mutationOptions =
    getCreateInvitationApiV1InvitationsPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Re-send a still-pending invitation (e.g. a stalled invite nudge).

Issues a fresh token + expiry for the same recipient and re-sends the email.
Requires admin. Does NOT re-publish USER_INVITED — a resend must not advance
the onboarding "invite teammates" counter.
 * @summary Resend Invitation
 */
export const resendInvitationApiV1InvitationsInvitationIdResendPost = (
  invitationId: string,
  signal?: AbortSignal
) => {
  return customInstance<CreateInvitationResponse>({
    url: `/api/v1/invitations/${invitationId}/resend`,
    method: 'POST',
    signal
  });
};

export const getResendInvitationApiV1InvitationsInvitationIdResendPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resendInvitationApiV1InvitationsInvitationIdResendPost
        >
      >,
      TError,
      { invitationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof resendInvitationApiV1InvitationsInvitationIdResendPost>
    >,
    TError,
    { invitationId: string },
    TContext
  > => {
    const mutationKey = [
      'resendInvitationApiV1InvitationsInvitationIdResendPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof resendInvitationApiV1InvitationsInvitationIdResendPost
        >
      >,
      { invitationId: string }
    > = (props) => {
      const { invitationId } = props ?? {};

      return resendInvitationApiV1InvitationsInvitationIdResendPost(
        invitationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ResendInvitationApiV1InvitationsInvitationIdResendPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof resendInvitationApiV1InvitationsInvitationIdResendPost>
    >
  >;

export type ResendInvitationApiV1InvitationsInvitationIdResendPostMutationError =
  HTTPValidationError;

/**
 * @summary Resend Invitation
 */
export const useResendInvitationApiV1InvitationsInvitationIdResendPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof resendInvitationApiV1InvitationsInvitationIdResendPost
        >
      >,
      TError,
      { invitationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof resendInvitationApiV1InvitationsInvitationIdResendPost>
  >,
  TError,
  { invitationId: string },
  TContext
> => {
  const mutationOptions =
    getResendInvitationApiV1InvitationsInvitationIdResendPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Revoke a pending invitation. Requires admin.
 * @summary Revoke Invitation
 */
export const revokeInvitationApiV1InvitationsInvitationIdDelete = (
  invitationId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/invitations/${invitationId}`,
    method: 'DELETE'
  });
};

export const getRevokeInvitationApiV1InvitationsInvitationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof revokeInvitationApiV1InvitationsInvitationIdDelete>
      >,
      TError,
      { invitationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof revokeInvitationApiV1InvitationsInvitationIdDelete>
    >,
    TError,
    { invitationId: string },
    TContext
  > => {
    const mutationKey = ['revokeInvitationApiV1InvitationsInvitationIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof revokeInvitationApiV1InvitationsInvitationIdDelete>
      >,
      { invitationId: string }
    > = (props) => {
      const { invitationId } = props ?? {};

      return revokeInvitationApiV1InvitationsInvitationIdDelete(invitationId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RevokeInvitationApiV1InvitationsInvitationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof revokeInvitationApiV1InvitationsInvitationIdDelete>
    >
  >;

export type RevokeInvitationApiV1InvitationsInvitationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Revoke Invitation
 */
export const useRevokeInvitationApiV1InvitationsInvitationIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof revokeInvitationApiV1InvitationsInvitationIdDelete>
      >,
      TError,
      { invitationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof revokeInvitationApiV1InvitationsInvitationIdDelete>
  >,
  TError,
  { invitationId: string },
  TContext
> => {
  const mutationOptions =
    getRevokeInvitationApiV1InvitationsInvitationIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Verify an invitation token (public endpoint).
 * @summary Verify Invitation Token
 */
export const verifyInvitationTokenApiV1InvitationsVerifyTokenGet = (
  token: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/invitations/verify/${token}`,
    method: 'GET',
    signal
  });
};

export const getVerifyInvitationTokenApiV1InvitationsVerifyTokenGetQueryKey = (
  token?: string
) => {
  return [`/api/v1/invitations/verify/${token}`] as const;
};

export const getVerifyInvitationTokenApiV1InvitationsVerifyTokenGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
    >,
    TError = HTTPValidationError
  >(
    token: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getVerifyInvitationTokenApiV1InvitationsVerifyTokenGetQueryKey(token);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
      >
    > = ({ signal }) =>
      verifyInvitationTokenApiV1InvitationsVerifyTokenGet(token, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!token,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type VerifyInvitationTokenApiV1InvitationsVerifyTokenGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
    >
  >;
export type VerifyInvitationTokenApiV1InvitationsVerifyTokenGetQueryError =
  HTTPValidationError;

export function useVerifyInvitationTokenApiV1InvitationsVerifyTokenGet<
  TData = Awaited<
    ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
  >,
  TError = HTTPValidationError
>(
  token: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useVerifyInvitationTokenApiV1InvitationsVerifyTokenGet<
  TData = Awaited<
    ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
  >,
  TError = HTTPValidationError
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useVerifyInvitationTokenApiV1InvitationsVerifyTokenGet<
  TData = Awaited<
    ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
  >,
  TError = HTTPValidationError
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Verify Invitation Token
 */

export function useVerifyInvitationTokenApiV1InvitationsVerifyTokenGet<
  TData = Awaited<
    ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
  >,
  TError = HTTPValidationError
>(
  token: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof verifyInvitationTokenApiV1InvitationsVerifyTokenGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getVerifyInvitationTokenApiV1InvitationsVerifyTokenGetQueryOptions(
      token,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
